import { patchState, signalStore, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { inject } from '@angular/core';
import { DepartmentsService } from '@dro/app/core/stores/departments/departments.service';
import { exhaustMap, pipe, tap } from 'rxjs';
import { setError, setLoading, withCallState } from '@ngrx-toolkit/core';
import { tapResponse } from '@ngrx/operators';
import type { Department } from '@dro/app/core/stores/departments/department.type';

type State = {
  departments: Array<Department>;
};

export const DepartmentsStore = signalStore(
  { providedIn: 'root' },
  withState<State>({ departments: [] }),
  withProps(() => ({
    _api: inject(DepartmentsService),
  })),
  withCallState(),
  withMethods(({ _api, ...store }) => ({
    load: rxMethod<void>(
      pipe(
        tap(() => patchState(store, setLoading())),
        exhaustMap(() =>
          _api.load().pipe(
            tapResponse({
              next: (departments) => patchState(store, { departments }, setLoading()),
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
  })),
  withHooks(({ load }) => ({
    onInit(): void {
      load();
    },
  })),
);
